import * as React from "react";
import GoogleMapsProvider from "@route-planner/components/GoogleMapsProvider";
import RoutePlanner from "@route-planner/components/RoutePlanner";

const Component = (props) => {
  return (
    <GoogleMapsProvider apiKey={process.env.REACT_APP_GOOGLE_KEY}>
      <RoutePlanner initialView="register" />
    </GoogleMapsProvider>
  );
};

const page = {
  routeProps: {
    path: "AlertsRegistration",
    component: Component,
  },
  name: "Alerts Registration",
  label: "Alerts Registration",
  title: "Alerts Registration",
  showOnMenu: false,
};

export default page;
